// import 'babel-polyfill';
import 'core-js';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import animated from 'animate.css';
import VTooltip from 'v-tooltip';
import Toasted from 'vue-toasted';
// import VueProgressBar from 'vue-progressbar';

import * as VueGtag from '@/third/vue-gtag.esm';
import App from './App.vue'; import router from './router';
import store from './store';
import '@/assets/css/common.less';


/* const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  location: 'bottom',
  inverse: false,
  position: 'absoult',
  autoFinish: true,
}; */

Vue.config.productionTip = false;
Vue.use(VTooltip);
Vue.use(animated);
Vue.use(Toasted);
Vue.use(VueGtag, {
  config: { id: 'G-7BVFVG2Q4Y' },
});
// Vue.use(VueProgressBar, options);


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
